var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row" id=\'row_'+
((__t=(idx))==null?'':__t)+
'\'>\n	<div class="col-md-3 col-sm-12">\n		<p><strong>'+
((__t=( translatorFrom ))==null?'':__t)+
'</strong></p>\n		<fieldset class="form-group ct_form1">\n			<div class="select_box">\n				<select class="form-control from_mt4_selectbox from_mt4" name="from_mt4[]" data-idx=\''+
((__t=(idx))==null?'':__t)+
'\' id=\'from_mt4_'+
((__t=(idx))==null?'':__t)+
'\'>\n					<option value=""></option>\n					';
 $.each(mt4DropDownOptions, function(val, text) { 
__p+='\n					<option value="'+
((__t=( val ))==null?'':__t)+
'">'+
((__t=( text ))==null?'':__t)+
'</option>\n					';
 }); 
__p+='\n				</select>\n			</div>\n			<span class="help-block help-error" for="from_mt4_'+
((__t=(idx))==null?'':__t)+
'"></span>\n		</fieldset>\n	</div>\n	<div class="col-md-3 col-sm-12">\n		<p><strong>'+
((__t=( translatorTo ))==null?'':__t)+
'</strong></p>\n		<fieldset class="form-group ct_form1">\n			<div class="select_box">\n				<select class="form-control to_mt4_selectbox to_mt4" name="to_mt4[]" data-idx="'+
((__t=(idx))==null?'':__t)+
'" id="to_mt4_'+
((__t=(idx))==null?'':__t)+
'">\n					<option value=""></option>\n					<!--';
 $.each(mt4DropDownOptions, function(val, text) { 
__p+='-->\n					<!--<option value="'+
((__t=( val ))==null?'':__t)+
'">'+
((__t=( text ))==null?'':__t)+
'</option>-->\n					<!--';
 }); 
__p+='-->\n				</select>\n			</div>\n			<span class="help-block help-error" for="to_mt4_'+
((__t=(idx))==null?'':__t)+
'"></span>\n		</fieldset>\n	</div>\n	<div class="col-md-5 col-sm-12">\n		<p><strong>'+
((__t=( translatorAmount ))==null?'':__t)+
'</strong></p>\n		<fieldset class="form-group ct_form1">\n			<input type="number" class="form-control amount" name="amount[]" data-idx="'+
((__t=(idx))==null?'':__t)+
'" id="amount_'+
((__t=(idx))==null?'':__t)+
'">\n			<span class="help-block help-error" for="amount_'+
((__t=(idx))==null?'':__t)+
'"></span>\n		</fieldset>\n	</div>\n	<div class="col-md-1 col-sm-12 table_minus_icon">\n		<a href="#" class="minus_sign" data-idx=\''+
((__t=(idx))==null?'':__t)+
'\' id="minus_'+
((__t=(idx))==null?'':__t)+
'"><span class="glyphicon glyphicon-minus-sign"></span></a>\n	</div>\n</div>\n\n';
}
return __p;
};
